import React from 'react';
import styled from 'styled-components';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import CarouselRWD from '../PageBuilder/CarouselRWD';

const defaultCarouselSection = {
  type: 'carousel_rwd_images',
  ratio_width: 4,
  ratio_height: 1,
  ratio_width_mobile: 4,
  ratio_height_mobile: 3,
  max_width: 960,
  auto_swipe_duration: 10,
  items: [
    {
      url: '',
      image: '',
      image_mobile: '',
    },
  ],
};

export default function N2gArticleDetailBanner(props) {
  const [landingPage, setLandingPage] = React.useState(null);

  React.useEffect(() => {
    async function fetchData() {
      setLandingPage(
        await JStorage.fetchOneDocument('page', {name: 'Landing'}),
      );
    }

    fetchData();
  }, []);

  const carouselSection =
    (landingPage?.sections || []).find(
      (it) => it.type === 'carousel_rwd_images',
    ) || defaultCarouselSection;

  return (
    <Wrapper>
      <CarouselRWD data={carouselSection} />
    </Wrapper>
  );
}

const Wrapper = styled.section`
  @media (max-width: 1000px) {
    margin-left: -20px;
  }
`;
